@if (isOpen) {
  <div
    class="absolute right-0 top-full z-20 mt-2 flex w-[162px] flex-col gap-2 rounded-lg bg-white p-4 shadow-[0_0_0_1px_rgba(0,0,0,0.05),0_10px_15px_-3px_rgba(0,0,0,0.1),0_4px_6px_-2px_rgba(0,0,0,0.05)]"
    role="menu"
  >
    @for (item of items; track item.id) {
      <button
        type="button"
        class="cursor-pointer rounded-md px-4 py-2 text-left text-sm leading-4 hover:bg-slate50"
        [ngClass]="item.tone === 'danger' ? 'text-red700' : 'text-slate900'"
        role="menuitem"
        (click)="selectItem(item)"
      >
        {{ item.label }}
      </button>
    }
  </div>
}
